<template>
  <div class="user_body">
    <div class="mbx">
      <img src="@/assets/icon_home_dd.png">
      <span>
        <span style="cursor: pointer;" @click="$router.push('/')">首页</span> > 
        <span style="cursor: pointer;" @click="$router.push('/cellsline/'+category.id)">{{category.title}}</span> > 
        <span >{{currentCate.title}}</span></span>
    </div>
    <div class="xb">
      <span>{{ currentCate.title }}</span>
      <span>{{currentCate.sdesc}}</span>
    </div>
    <div class="ld_list" v-html="currentCate.content"></div>
    <!-- <div class="ld_list">
      <div class="ld_item" v-for="(item,index) in 4" :key="index">
        <div class="ld_content" v-if="index % 2 === 1">
          <span>产品亮点 1</span>
          <span>细胞产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品，产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品。</span>
        </div>
        <img src="@/assets/icon_banner1.png">
        <div class="ld_content" v-if="index % 2 === 0">
          <span>产品亮点 1</span>
          <span>细胞产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品，产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品特点产品。</span>
        </div>
      </div>
    </div> -->
    <div class="position_buy" id="buy"></div>
    <div class="banner22s" >
      <span class="banner22s_span">选择{{ currentCate.title }}</span>
      <div class="carousel-container">
        <!-- 图片列表 -->
        <div class="carousel-track" v-if="goods.length > 0">
          <!-- 循环渲染双倍图片实现无缝衔接 -->
           <div v-for="(item, index) in goods" :key="index" class="carousel-item3" @click="$router.push('/productinfo/'+item.id+'?cateid='+currentCate.id)">
            <img :src="item.thumb" class="carousel-item2_img2">
            <span class="goods-title">{{item.title}}</span>
          </div>
        </div>
        <div v-else> <el-empty description="暂无数据"></el-empty> </div>
      </div>
    </div>

     <div class="banner22s">
      <span class="banner22s_span">选择相关产品</span>
      <div class="carousel-container">
        <!-- 图片列表 -->
        <div class="carousel-track">
            <div v-for="(item, index) in associationCategoryGoods" :key="index" class="carousel-item3" @click="$router.push('/productinfo/'+item.id+'?cateid='+item.cateid)">
            <img :src="item.thumb" class="carousel-item2_img2">
            <span class="goods-title">{{item.title}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
import Banner from "@/components/Banner";
import { mapGetters } from 'vuex'

export default {
  name: "CellsLine",
  components: { Banner },
  data() {
    return {
      currentIndex: 0,
      goods:[],
      category:{},
      currentCate:{},
      associationCategoryGoods:[]
    };
  },
  computed: {
    ...mapGetters(['base'])
  },
  watch: {
    base: {
      handler(newVal) {
        this.getCurrentCate()
      },
      immediate: true
    },
    '$route.params.id': {
        handler() {
          console.log("aaa", this.$route.params.id);
          this.goods = []
          this.getGoods()
          this.getCurrentCate()
          this.getAssociationCategoryGoods()
        },
        immediate: true
      }
  },
 
  beforeMount() {

    
  },
  mounted() {},
  methods: {
    getCurrentCate(){
      if(!this.base.category || this.base.category.length == 0){
        return
      }
     this.base.category.forEach(item => {
      if(item.id == this.$route.params.id){
        this.currentCate = item
      }
      item.child.forEach(item2 => {
        if(item2.id == this.$route.params.id){
          this.category = item
          this.currentCate = item2
        }
      })
     })
   
    },
    getGoods(){
      this.$api.getGoods({
        category_id:this.$route.params.id,
        page:1,
      }).then(res => {
        if(res.code == 1){
						 this.goods = res.data;
            if(this.$route.query.to == 'buy'){
              document.getElementById('buy').scrollIntoView({behavior: 'smooth'});
            }
					}
					else{
						// this.$message.error(res.message);
					}
      })
    },
    async getAssociationCategoryGoods() {
      this.loading = true
      try {
        const res = await this.$api.getAssociationCategoryGoods({ category_id: this.$route.params.id })
        if (res.code == 1) {
          res.data.list.forEach(item => {
            let goods = item.goods.map(goodsItem=>{
              return {
                ...goodsItem,
                cateid: item.id
              }
            })
            this.associationCategoryGoods.push(...goods)
          })
          console.log('this.associationCategoryGoods',this.associationCategoryGoods)
        } else {
          this.associationCategoryGoods = []
        }
        console.log(res)
      } catch (err) {
        console.log(err)
        this.$message.error(err.message)
      } finally {
        this.loading = false
      }
    }
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  box-sizing: border-box;
  margin-top: 91px;
}
.mbx {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
  background: #ffffff;
  padding-left: 15%;
  padding-right: 15%;
}
.mbx img {
  width: 14.53px;
  height: 13.46px;
}
.mbx span {
  color: rgba(136, 136, 136, 1);
  font-size: 12px;
}
.xb{
     background: #ffffff;
  padding-left: 15%;
  padding-right: 15%;
}
.xb span:nth-child(odd) {
  color: rgba(51, 51, 51, 1);
  font-size: 28px;
  line-height: 42px;
  font-weight: 700;
  margin-right: 10px;
}
.xb span:nth-child(even) {
  color: rgba(51, 51, 51, 1);
  font-size: 28px;
  line-height: 42px;
}
.ld_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 20px;
  background: #ffffff;
  padding-left: 15%;
  padding-right: 15%;
}
.ld_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;
}
.ld_item img {
  width: 48%;
  height: 450px;
}
.ld_content {
  width: 48%;
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.ld_content span:nth-child(odd) {
  font-size: 28px;
  line-height: 44px;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
}
.ld_content span:nth-child(even) {
  font-size: 28px;
  line-height: 44px;
  color: rgba(51, 51, 51, 1);
}
.position_buy{
  position: relative;
  top: -100px;
}
.banner22s {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
}
.banner22s_span {
  margin-left: 15%;
  color: #3e3e3e;
  font-size: 44px;
  line-height: 64px;
  margin-bottom: 15px;
}

.carousel-container {
  margin-left: 15%;
  margin-right: 15%;
}

.carousel-track {
  height: 100%;
  width: 100%; /* 双倍宽度容纳重复图片 */
  display: flex;
  flex-wrap: wrap;

  gap: 15px;
}

.carousel-item {
  flex: 0 0 24%; /* 每张占25%宽度 */
  width: 280px;
  height: 330px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.carousel-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}
.carousel-item span {
  height: 50px;
  width: 280px;
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: #333333;
}
.carousel-item3 {
  cursor: pointer;
  width: calc(25% - 15px);
  height: 330px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #ffffff;
   box-shadow: 0px 0px 20px #eeeeee; 
   &:hover{
    box-shadow: 0px 0px 20px #aaaaaa;
   }
}

.carousel-item2_img2 {
  width: 100%;
  height: 264px;
  object-fit: cover; 
}
.goods-title{
  width: 90%;
padding: 10px 10px;
font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: 20px;
color: #3E3E3E;
text-align: center;
text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
}
</style>
 

